import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-monthly-totals-info-dialog',
  templateUrl: './monthly-totals-info-dialog.component.html',
  styleUrls: ['./monthly-totals-info-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyTotalsInfoDialogComponent {
  constructor(private dialog: MatDialog) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
